export function stringToSlug(s) {
    return s.toLowerCase().replace(/[^\w-]+/g, '-').replace(/--+/g, '-').replace(/^-+|-+$/g, '');
}
